const state = {
  navbarBrandLogo: null,
  navbarBrandText: 'TransitionCRM',
};

const getters = {
  getNavbarBrandLogo: state => state.navbarBrandLogo,
  getNavbarBrandText: state => state.navbarBrandText,
};

const mutations = {
  updateNavbarBrandDetails(state, { logo, brandText }) {
    state.navbarBrandLogo = logo;
    state.navbarBrandText = brandText;
  },
};

const actions = {
  updateNavbarBrandDetails({ commit }, linkedEntity) {
    if (linkedEntity) {
      commit('updateNavbarBrandDetails', {
        logo: linkedEntity.logo_url,
        brandText: linkedEntity.name,
      });
    }
  },
};

export const navbarConfig = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
